
const AirdropAnimate = () => {
   return (
      <div className="adChartPt">
         <div className="adChart">
            <img src={require("../../assets/images/home/airdropanimate/coin.png")} alt="coin" className="airDropCoin adc_1" />
            <img src={require("../../assets/images/home/airdropanimate/coin.png")} alt="coin" className="airDropCoin adc_2" />
            <img src={require("../../assets/images/home/airdropanimate/coin.png")} alt="coin" className="airDropCoin adc_3" />
            <img src={require("../../assets/images/home/airdropanimate/coin.png")} alt="coin" className="airDropCoin adc_4" />

            <div className="adChartLines">
               <div className="adChartLine ln_1"></div>
               <div className="adChartLine ln_2"></div>
               <div className="adChartLine ln_3"></div>
               <div className="adChartLine ln_4"></div>
               <div className="adChartLine ln_5"></div>
               <div className="adChartLine ln_6"></div>
               <div className="adChartLine ln_7"></div>
               <div className="adChartLine ln_8"></div>
               <div className="adChartLine ln_9"></div>
               <div className="adChartLine ln_10"></div>
               <div className="adChartLine ln_11"></div>
               <div className="adChartLine ln_12"></div>
               <div className="adChartLine ln_13"></div>
               <div className="adChartLine ln_14"></div>
               <div className="adChartLine ln_15"></div>
               <div className="adChartLine ln_16"></div>
               <div className="adChartLine ln_17"></div>
               <div className="adChartLine ln_18"></div>
            </div>
         </div>
      </div>
   )
}
export default AirdropAnimate;